const mutations = {
  SET_DASHBOARD (state, payload) {
    state.dashboard = payload
  },
  SET_DATA_CART (state, payload) {
    state.dataCart = payload
  },

  SET_LOADING_DASHBOARD (state, payload) {
    state.isLoadingDashboard = payload
  },

  SET_TOTAL_WEEKLY_SALES (state, payload) {
    state.totalWeeklySales = payload
  },
}

export default mutations
